import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-list_mode",
  "use": "icon-list_mode-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" class=\"svg-icon\" id=\"icon-list_mode\"><path d=\"M4.228 2h8.605a.667.667 0 0 0 0-1.334H4.228a.667.667 0 0 0 0 1.333m0 5.315h8.574a.667.667 0 0 0 0-1.333H4.228a.667.667 0 0 0 0 1.333m8.605 4.013H4.228a.667.667 0 0 0 0 1.333h8.605a.667.667 0 0 0 0-1.333M.5 1.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m0 5.308a1 1 0 1 0 2 0 1 1 0 0 0-2 0m0 5.353a1 1 0 1 0 2 0 1 1 0 0 0-2 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol